import { registrar } from '@modules/aawz-intelligence-v2/ui-registry'
import registryFp from './ia/registry'
import * as FPStore from './store'

export function fpModule({ store }) {
  // ⚠️ Guarda de REENTRADA (padrão do `modules/crm/index.js`). Sem ela, uma
  // segunda chamada registraria o store de novo e cairia no `registrar`
  // abaixo, que RECUSA chave repetida por desenho (override silencioso entre
  // módulos é bug) — o boot passaria a estourar em vez de ignorar.
  if (typeof store.hasModule === 'function' && store.hasModule('financialPlanning')) {
    return
  }

  store.registerModule('financialPlanning', { ...FPStore, namespaced: true })

  // Os cartões do módulo dentro da conversa (spec-011, [T010]). O MÓDULO se
  // registra e o agregado só consulta — é o que permite o `chat-message.vue`
  // desenhar um cartão de FP sem importar nada daqui.
  //
  // Aqui, e não numa view: o cartão pode chegar em QUALQUER conversa, e
  // registrar na view faria o mesmo `tool_result` virar cartão numa tela e
  // `fallback-card` na outra.
  registrar(registryFp)
}
